<div class="vvcr-app">
  <!-- <app-banner></app-banner> -->
  <app-header></app-header>
  <div class="router-container">
    <router-outlet (activate)="onActivate()"></router-outlet>
  </div>
  <app-footer></app-footer>
</div>
